import ReactDOM from "react-dom/client";
import { Center, ChakraProvider, ColorModeScript, localStorageManager } from "@chakra-ui/react";
import "@noli/noli-ui/dist/style/index.css";
// import { createHashHistory } from "history";
import "./index.scss";
import Global from "./pages/Global";
import { initializeLang } from "@/utils/lang";
// import * as Sentry from "@sentry/react";
// import { BrowserTracing } from "@sentry/tracing";
// import packageData from "../package.json";
// import ahamoment from "ahamoment.js";
// import config from "@/config";
import { theme } from "./theme";
// import React from "react";

// const history = createHashHistory();
initializeLang();

/**
 * @REVIEW theme.config 里设置的 `initialColorMode` 与 localStorage 里的 `charkra-ui-color-theme` 冲突，看似是 Chakra 还没有解决的问题。
 * 类似 issue: https://github.com/chakra-ui/chakra-ui/issues/6790
 * 只是初始化时的问题，影响不大
 * 解决方式：目前先手动设置 localStorage 的值为 dark
 */
// localStorageManager.set("dark");
// ahamoment.init(config.ahaTimeEvnId);
// if (process.env.REACT_APP_ENV === "production" && process.env.NODE_ENV !== "development") {
//   Sentry.init({
//     dsn: "https://f2090621d2754dca95ca9925a6022685@sentry.nolibox.com/10",
//     integrations: [new BrowserTracing()],
//     release: `${packageData.version}`,
//     environment: process.env.REACT_APP_ENV,
//     sampleRate: 1,
//     attachStacktrace: true,
//     tracesSampleRate: 1.0,
//     maxBreadcrumbs: 100,
//     normalizeDepth: 100,
//     beforeSend(event) {
//       event.user = {
//         token: localStorage.token,
//         userId: localStorage.noliUserId,
//       };
//       return event;
//     },
//   });
// }
// window.addEventListener(
//   "error",
//   (event) => {
//     const target = event.target as HTMLScriptElement | HTMLImageElement;
//     if (target && (target.tagName === "IMG" || target.tagName === "SCRIPT")) {
//       Sentry.captureException(new Error(`[resource-load-error] ${target.tagName}: ${target.src}`), {
//         level: "fatal",
//       });
//     }
//   },
//   true,
// );
const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <>
    <ColorModeScript initialColorMode={theme.config.initialColorMode} />
    <ChakraProvider theme={theme} colorModeManager={localStorageManager}>
      <Global />
    </ChakraProvider>
  </>,
);
